import React from 'react';
import { BriefcaseIcon, StarIcon, ShieldIcon, CalendarIcon } from 'lucide-react';
export function Experience() {
  const securityExperiences = [{
    period: '2022 - heden',
    role: 'Zelfstandig Beveiliger',
    description: 'Professionele beveiligingsdiensten met focus op objectbeveiliging, toegangscontrole en calamiteitenbeheersing.'
  }, {
    period: '2022 - heden',
    role: 'BHV Ploegleider',
    description: 'Gecertificeerd voor coördinatie en leiding bij calamiteiten en noodsituaties.'
  }];
  const pastExperiences = [{
    period: '2015 - 2022',
    role: 'Diverse functies bij Dirk van den Broek',
    description: 'Werkzaam geweest als teamleider, verkoopmedewerker en vulploegmedewerker. Verantwoordelijkheden omvatten o.a. team aansturing, sleutelbeheer en kluiscontrole.'
  }];
  const skills = ['Observatie & Analyse', 'Beveiligingsprotocollen', 'Calamiteitenbeheersing', 'Conflicthantering', 'Rapportage & Documentatie', 'Toegangscontrole'];
  return <section className="py-16 border-b border-gray-800" data-id="element-225">
      <div className="max-w-6xl mx-auto" data-id="element-226">
        <h2 className="text-3xl font-bold mb-8 flex items-center gap-3" data-id="element-227">
          <ShieldIcon className="w-8 h-8 text-orange-500" data-id="element-228" />
          Beveiligingservaring
        </h2>
        <div className="grid md:grid-cols-5 gap-8 mb-12" data-id="element-229">
          <div className="md:col-span-3" data-id="element-230">
            <div className="mb-10" data-id="element-231">
              <h3 className="text-xl font-semibold mb-4 flex items-center gap-2" data-id="element-232">
                <ShieldIcon className="w-5 h-5 text-orange-500" data-id="element-233" />
                Huidige werkzaamheden
              </h3>
              <div className="space-y-8" data-id="element-234">
                {securityExperiences.map((exp, index) => <div key={index} className="relative pl-8 border-l-2 border-orange-500" data-id="element-235">
                    <div className="absolute -left-[9px] top-0 w-4 h-4 rounded-full bg-orange-500" data-id="element-236"></div>
                    <div className="text-sm text-orange-500 font-semibold mb-1" data-id="element-237">
                      {exp.period}
                    </div>
                    <h3 className="text-xl font-bold mb-2" data-id="element-238">{exp.role}</h3>
                    <p className="text-gray-400" data-id="element-239">{exp.description}</p>
                  </div>)}
              </div>
            </div>
            <div className="mt-10" data-id="element-240">
              <h3 className="text-xl font-semibold mb-4 flex items-center gap-2" data-id="element-241">
                <CalendarIcon className="w-5 h-5 text-gray-500" data-id="element-242" />
                Eerdere werkervaring
              </h3>
              <div className="space-y-8" data-id="element-243">
                {pastExperiences.map((exp, index) => <div key={index} className="relative pl-8 border-l-2 border-gray-600" data-id="element-244">
                    <div className="absolute -left-[9px] top-0 w-4 h-4 rounded-full bg-gray-600" data-id="element-245"></div>
                    <div className="text-sm text-gray-500 font-semibold mb-1" data-id="element-246">
                      {exp.period}
                    </div>
                    <h3 className="text-lg font-bold mb-2 text-gray-300" data-id="element-247">
                      {exp.role}
                    </h3>
                    <p className="text-gray-500" data-id="element-248">{exp.description}</p>
                  </div>)}
              </div>
            </div>
          </div>
          <div className="md:col-span-2" data-id="element-249">
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg" data-id="element-250">
              <h3 className="text-xl font-bold mb-4 flex items-center gap-2" data-id="element-251">
                <ShieldIcon className="w-5 h-5 text-orange-500" data-id="element-252" />
                Beveiligingsvaardigheden
              </h3>
              <ul className="space-y-3" data-id="element-253">
                {skills.map((skill, index) => <li key={index} className="flex items-center gap-2" data-id="element-254">
                    <StarIcon className="w-5 h-5 text-orange-500" data-id="element-255" />
                    <span data-id="element-256">{skill}</span>
                  </li>)}
              </ul>
              <div className="mt-8 p-5 bg-gray-700 rounded-lg border-l-2 border-orange-500" data-id="element-257">
                <div className="text-sm italic text-gray-300" data-id="element-258">
                  "Emre combineert een scherp oog voor detail met een
                  professionele houding. Zijn focus op veiligheid en preventie
                  maakt hem een betrouwbare partner voor beveiligingsdiensten."
                </div>
                <div className="mt-3 font-semibold" data-id="element-259">
                  — Voormalig opdrachtgever
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}